import { Trans } from '@lingui/react'

import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { Hidden } from '@twisto/components/atoms/hidden'
import { BigPhoneVerificationIcon } from '@twisto/icons'

import * as styles from './otp-verification-sms-step-headline.styles'

type Props = {
  phoneNumber: string
}
export const OtpVerificationSmsStepHeadline = ({ phoneNumber }: Props) => (
  <Headline css={styles.headlineSection}>
    <Hidden xsDown>
      <HeadlineIcon>
        <BigPhoneVerificationIcon color="primary" height="100%" width="100%" />
      </HeadlineIcon>
    </Hidden>

    <HeadlineTitle>
      <Trans id="flow.otpVerificationSmsStep.title" />
    </HeadlineTitle>

    <HeadlineSubtitle>
      <Trans
        id="flow.otpVerificationSmsStep.subtitle"
        values={{
          phoneNumber,
        }}
      />
    </HeadlineSubtitle>
  </Headline>
)
